import React, { useEffect, useState } from "react";
import styles from "./../celebrationEvent.module.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Table from "../../../component/table";
import { deleteIcon, editIcon } from "../../../../utils/svg.file";

import DeleteModal from "../../../component/modal/deleteModal";
import swal from "sweetalert";
import {
  celebrationlandingList,
  deleteCelebrationimages,
} from "../../../../api/adminPanel/giftCardApi";
import { showCelebrationText } from "../../../../api/adminPanel/celebrationAPI";

export default function ManageCelebrationLandingPageContent() {
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState("");
  const [deleteId, setDeletedId] = useState("");
  const [featuredList, setFeaturedList] = useState([]);

  const handleShowDeleteModal = (id) => {
    setDeletedId(id);
    setShowDeleteModal(true);
  };
  const hideDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const columns = [
    { field: "id", headerName: "SNo.", width: 100 },
    {
      field: "text",
      headerName: "Description",
      height: 150,
      width: 700,
    },
    {
      field: "Action",
      width: 150,
      renderCell: (cellValues) => {
        return (
          <>
            <span
              className={styles.edit_icon_btn}
              onClick={() => {
                navigate(
                  `/edit-celebration-landing-page-content/${cellValues.row.id}`
                );
              }}
            >
              {editIcon}
            </span>
            {/* <span
              className={styles.delete_icon_btn}
              onClick={() => {
                handleShowDeleteModal(cellValues.row.id);
              }}
            >
              {deleteIcon}
            </span> */}
          </>
        );
      },
    },
  ];

  let rows = [
    { id: 1, text: "dsd" },
    { id: 2, description: "dsds" },
  ];

  const handlelandingCelebration = async () => {
    const response = await showCelebrationText();

    if (response.remote === "success") {
      setFeaturedList(response.data.data)
    } else {
      swal("Something Went Wrong!");
    }
  };
  useEffect(() => {
    handlelandingCelebration();
  }, []);
  const handleDelete = async (id) => {
    const response = await deleteCelebrationimages(id);

    if (response.remote === "success") {
      hideDeleteModal();
      swal("Deleted Successfully!");
      handlelandingCelebration();
    } else {
    }
  };


  return (
    <>
      <div className={styles.job_list_page}>
        <div className="">
          <div className={styles.card_body}>
            <div className="d-flex align-items-center justify-content-between mt-2 mb-3">
              <div className={styles.page_title}>
                <h3>Manage Landing Page Content</h3>
              </div>
              <Button
                className={styles.main_button}
                onClick={() =>
                  navigate("/add-celebration-landing-page-content")
                }
              >
                Add Content
              </Button>
            </div>
            <Table rows={featuredList} columns={columns} />
          </div>
        </div>
      </div>
      <DeleteModal
        showDeleteModal={showDeleteModal}
        handleDelete={handleDelete}
        hideDeleteModal={hideDeleteModal}
        handleShowDeleteModal={handleShowDeleteModal}
        deleteId={deleteId}
      />
    </>
  );
}
